import(/* webpackMode: "eager" */ "/vercel/path0/packages/examples/src/components/charts/BarChart.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/packages/examples/src/components/shared/RevizOutput.tsx")